var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40642 5.37797H10.7775V16.9098C10.7775 17.0598 10.893 17.1825 11.0342 17.1825H12.9594C13.1005 17.1825 13.216 17.0598 13.216 16.9098V5.37797H15.5936C15.8086 5.37797 15.9273 5.1155 15.7957 4.93824L12.2021 0.104631C12.1781 0.0720376 12.1474 0.0456777 12.1124 0.0275495C12.0774 0.00942119 12.039 0 12 0C11.961 0 11.9226 0.00942119 11.8876 0.0275495C11.8525 0.0456777 11.8219 0.0720376 11.7979 0.104631L8.20428 4.93484C8.07273 5.1155 8.19144 5.37797 8.40642 5.37797ZM23.7433 15.8872H21.8182C21.677 15.8872 21.5615 16.0099 21.5615 16.1599V21.4093H2.4385V16.1599C2.4385 16.0099 2.32299 15.8872 2.18182 15.8872H0.256684C0.115508 15.8872 0 16.0099 0 16.1599V22.9092C0 23.5125 0.458824 24 1.02674 24H22.9733C23.5412 24 24 23.5125 24 22.9092V16.1599C24 16.0099 23.8845 15.8872 23.7433 15.8872Z",
    fill: "#009AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b1b2309d.svg";
export { ForwardRef as ReactComponent };